import React, { Component } from "react"

import SvgSearch from "../../../shared/_svgs/small/Search"

class SearchBox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: "",
    }
  }
  static defaultProps = {
    useOriginalMarkup: true,
    formTextModifier: "",
    placeholderText: "Søg...",
  }

  handleInput(e) {
    if (e === document.activeElement) {
      this.setState({ value: e.value }, () => {
        this.props.handleSearch(e.value)
      })
    }
  }

  handleKeyDown(e) {
    if (e.keyCode === 27) {
      //ESC
      this.props.onBlurHandler()
      //e.target.dispatchEvent(new Event('blur'))
    }
    if (e.keyCode === 13) {
      //Enter
      this.handleRedirectToSearchPage(e)
    }
  }

  handleRedirectToSearchPage(e) {
    const lang = this.props.searchUrl.split("/").length > 3 ? this.props.searchUrl.split("/")[1] : null
    const newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      (this.props.brand
        ? (lang ? "/" + lang : "") + "/shop/maerker/" + this.props.brand
        : this.props.searchUrl + "?q=" + this.state.value + "&c=shop")
    window.location.href = newurl
  }

  render() {
    let wrappedMarkup = (
      <div className={`form-text form-text--search ${this.props.formTextModifier}`}>
        <input
          autoComplete="off"
          type="text"
          placeholder={this.props.placeholderText}
          value={this.props.value}
          onFocus={(e) => this.props.onFocusHandler(e.currentTarget.value)}
          onKeyDown={(e) => this.handleKeyDown(e)}
          onInput={(e) => this.handleInput(e.currentTarget)}
        />
        <button onClick={(e) => this.handleRedirectToSearchPage(e)}>
          <SvgSearch />
        </button>
      </div>
    )

    return this.props.useOriginalMarkup ? (
      <input
        autoComplete="off"
        type="text"
        placeholder={this.props.placeholderText}
        value={this.props.value}
        onFocus={(e) => this.props.onFocusHandler(e.currentTarget.value)}
        onKeyDown={(e) => this.handleKeyDown(e)}
        onInput={(e) => this.handleInput(e.currentTarget)}
      />
    ) : (
      wrappedMarkup
    )
  }
}

export default SearchBox
